const AddContactButton = () => import('../../components/add-contact-button/index.vue');

export default {
    name: 'ContactsPage',
    
    components: {
        'add-contact-button': AddContactButton
    },

    data() {
        return {
            list: []
        };
    },

    computed: {
        contacts_list() {
            return this.$store.state.contacts.contacts_list;
        }
    },

    watch: {
        contacts_list: 'setList'
    },

    created() {
        this.setList();
        this.$store.commit('setMenuDetails', { title: 'Contacts', slug: 'contacts', back_url: '/action/operations' });
    },

    methods: {
        setList() {
            const list = this.$store.getters.getContactsList
            this.$store.commit('setMenuItems', list);
            this.list = list;
        },
    }
};